<template>
    <div class="modal" ref="savePatternModal" id="savePatternModal" role="dialog">
        <div class="modal-dialog modal-sm">
            <div class="modal-content">

                <div class="modal-header bg-teal text-white font-bold">
                    New Search Pattern
                </div>

                <div class="modal-body bg-white">
                    <input @keydown="form.errors.clear($event.target.name)" ref="patternName" type="search"
                        class="text-grey-darkest w-full focus:outline-none p-2 text-base rounded-sm border-1"
                        placeholder="Type the new pattern's name..." v-model="form.name"
                        :class="{
                            'bg-white': !form.errors.has('name'),
                            'bg-red-lightest': form.errors.has('name'),
                            'mb-2': form.errors.has('name') || form.errors.has('pattern')
                        }">
                    <div class="text-red text-xs" v-if="form.errors.has('name') || form.errors.has('pattern')">
                        {{ form.errors.get('name') ? form.errors.get('name') : form.errors.get('pattern') }}
                    </div>
                </div>

                <div class="modal-footer">
                    <button class="btn btn-primary" @click.prevent="save()">
                        Save
                    </button>
                    <button class="btn btn-link" type="reset" data-dismiss="modal">
                        Close
                    </button>
                </div>

            </div>
        </div>
    </div>
</template>

<script>

import Form from "../../../utils/form";

export default {
    name: 'save-pattern',
    data() {
        return {
            form: new Form({
                name: '',
                pattern: null
            })
        }
    },

    mounted() {
        $("#savePatternModal").on('hidden.bs.modal', () => this.clear());
    },

    methods: {
        open(pattern) {
            $(this.$el).modal('show');
            this.form.pattern = JSON.stringify(pattern);
        },

        close() {
            this.clear();
            $(this.$el).modal('hide');
        },

        clear() {
            this.form.name = '',
            this.form.pattern = null
        },

        save() {
            this.form.post('/api/search-patterns')
                .then( (data) => {
                    this.close();

                    swal({
                        title: 'Created',
                        text: data.message,
                        type: 'success',
                        showCancelButton: false,
                        confirmButtonColor: '#01B1AF',
                        confirmButtonText: 'OK!',
                        closeOnConfirm: true,
                    });
                })
                .catch( (err) => {
                    console.error(err);
                });
        }
    }
}
</script>
